import { render } from "./ModalConfirmDeleteUser.vue?vue&type=template&id=47b212d5"
import script from "./ModalConfirmDeleteUser.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeleteUser.vue?vue&type=script&lang=js"

import "./ModalConfirmDeleteUser.vue?vue&type=style&index=0&id=47b212d5&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__